import BaseController from "confinus_ui/base_controller";

interface VariantData {
  encoded_id: string;
  sell_uom: string;
  humanized_uom: string;
}

interface ProductMetadata {
  encoded_id: string;
  variant_id: string;
  sell_uom: string;
  variants: VariantData[];
}

export default class extends BaseController {
  static targets = [
    "variantContainer",
    "variantButtons",
    "variantEncodedIdInput",
  ];

  declare readonly variantContainerTarget: HTMLElement;
  declare readonly variantButtonsTarget: HTMLElement;
  declare readonly variantEncodedIdInputTarget: HTMLInputElement;

  productSelected(event: CustomEvent) {
    const { metadata } = event.detail as {
      id: string;
      label: string;
      metadata: ProductMetadata;
    };
    if (!metadata?.variants?.length) return;

    const variants = metadata.variants;

    if (variants.length === 1) {
      this.selectVariant(variants[0]);
      this.renderVariantButtons(variants);
      this.variantContainerTarget.classList.remove("hidden");
    } else {
      this.variantEncodedIdInputTarget.value = "";
      this.renderVariantButtons(variants);
      this.variantContainerTarget.classList.remove("hidden");
    }
  }

  productCleared() {
    this.variantContainerTarget.classList.add("hidden");
    this.variantButtonsTarget.innerHTML = "";
    this.variantEncodedIdInputTarget.value = "";
  }

  handleVariantClick(event: Event) {
    const button = (event.target as HTMLElement).closest(
      "[data-variant-encoded-id]",
    ) as HTMLElement | null;
    if (!button) return;

    const encodedId = button.dataset.variantEncodedId || "";
    this.variantEncodedIdInputTarget.value = encodedId;

    this.variantButtonsTarget
      .querySelectorAll("[data-variant-encoded-id]")
      .forEach((btn) => {
        btn.classList.remove("bg-blue-600", "text-white", "border-blue-600");
        btn.classList.add("bg-white", "text-gray-700", "border-gray-300");
      });

    button.classList.remove("bg-white", "text-gray-700", "border-gray-300");
    button.classList.add("bg-blue-600", "text-white", "border-blue-600");
  }

  private selectVariant(variant: VariantData) {
    this.variantEncodedIdInputTarget.value = variant.encoded_id;
  }

  private renderVariantButtons(variants: VariantData[]) {
    this.variantButtonsTarget.innerHTML = "";

    variants.forEach((variant, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.dataset.variantEncodedId = variant.encoded_id;
      button.dataset.action =
        "platform-admin--add-proposal-item#handleVariantClick";
      button.textContent = variant.humanized_uom;

      const isSelected =
        variants.length === 1 ||
        this.variantEncodedIdInputTarget.value === variant.encoded_id;

      if (isSelected) {
        button.className =
          "px-4 py-2 text-sm font-medium rounded-md border bg-blue-600 text-white border-blue-600 cursor-pointer transition-colors";
        if (variants.length === 1) {
          this.variantEncodedIdInputTarget.value = variant.encoded_id;
        }
      } else {
        button.className =
          "px-4 py-2 text-sm font-medium rounded-md border bg-white text-gray-700 border-gray-300 hover:bg-gray-50 cursor-pointer transition-colors";
      }

      this.variantButtonsTarget.appendChild(button);
    });
  }
}
